import React from "react";
import { useTranslation } from "react-i18next";
import styles from "./playerSelect.module.css";
import { useSelector } from "react-redux";

function PlayerCard({ player, setPlayer, data, id }) {
  let gender = data?.gender === 1 ? styles.male : styles.female;
  let image =
    data?.gender === 1
      ? require("../../assets/images/games/quiz/home.png")
      : require("../../assets/images/games/quiz/muie.png");

  return (
    <button
      type="button"
      onClick={() => setPlayer(player === id ? 0 : id)}
      className={`${styles.player} ${gender} ${
        player === id ? styles.active : ""
      }`}
    >
      <div className="image-wrapper">
        <div className="background-gray"></div>
        <div className="background"></div>
        <div className="image-container">
          <img src={image} alt={`player${id}`} />
        </div>
      </div>
      <div className={styles.name}>
        <span>{data.name}</span>
      </div>
    </button>
  );
}

export default function PlayerSelect({
  description,
  player,
  setPlayer,
  onClick,
}) {
  const { t } = useTranslation();
  const { player1, player2 } = useSelector((state) => state.players);

  return (
    <div className="flex flex-col h-full">
      <div>
        <span className="text-base leading-3">{description}</span>
      </div>
      <div className="mt-10 mb-2">
        <h2 className="text-center text-2xl font-medium">
          {t("selectPlayer")}
        </h2>
      </div>
      <div className="flex-1 flex items-end">
        <PlayerCard
          id={1}
          player={player}
          setPlayer={setPlayer}
          data={player1}
        />
        <PlayerCard
          id={2}
          player={player}
          setPlayer={setPlayer}
          data={player2}
        />
      </div>
      <div className="mb-10 mt-10">
        <button
          type="button"
          onClick={onClick}
          disabled={player === 0}
          className="btn btn-brand w-full"
        >
          {t("start")}
        </button>
      </div>
    </div>
  );
}
